'use client'
import { useTheme, useTranslation } from '@payloadcms/ui'
import React from 'react'

const BeforeLogin: React.FC = () => {
  const { theme } = useTheme()
  const { i18n } = useTranslation()

  return (
    <div className="headerLogin">
      <h2 className="text-xl font-semibold">
      {i18n?.language === 'en' ? (
        'Sign in'
      ) : i18n?.language === 'fr' ? (
        'Connexion'
      ) : (
        'الدخول'
      )}
      </h2>
      <img src="/login/login.png" alt="" className="loginImage" />
    </div>
  )
}

export default BeforeLogin
